import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=355a6e8a&scoped=true&"
import script from "./VideoCard.vue?vue&type=script&lang=ts&"
export * from "./VideoCard.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=355a6e8a&prod&scoped=true&lang=css&"
import style1 from "./VideoCard.vue?vue&type=style&index=1&id=355a6e8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a6e8a",
  null
  
)

export default component.exports